const productTypeOptions = [
  { label: "HP", value: 0 },
  { label: "PCP", value: 1 },
]

export default productTypeOptions;
